<template>
  <header class="site-header">
    <LayoutHeaderTopBar />
    <div class="header-main flex ">
      <div class="flex w-full items-center">
        <LayoutHeaderLogo />
        <LayoutHeaderHeaderNavigation class="ml-auto" />
        <LayoutHeaderHeaderActions 
          :current-locale="currentLocale" 
          :fallback-locale="locale"
          @toggle-offcanvas="isOffcanvasOpen = !isOffcanvasOpen"
          @locale-change="handleLocaleChange"
        />
      </div>
    </div>
  </header>

  <Transition name="floating-header">
    <header v-show="isFloatingVisible" class="site-header site-header--floating">
      <div class="header-main flex ">
        <div class="flex w-full items-center">
          <LayoutHeaderLogo />
          <LayoutHeaderHeaderNavigation class="ml-auto" />
          <LayoutHeaderHeaderActions 
            :current-locale="currentLocale" 
            :fallback-locale="locale"
            @toggle-offcanvas="isOffcanvasOpen = !isOffcanvasOpen"
            @locale-change="handleLocaleChange"
          />
        </div>
      </div>
    </header>
  </Transition>

  <LayoutHeaderMobileOffcanvas 
    :is-open="isOffcanvasOpen" 
    :current-locale="currentLocale"
    :fallback-locale="locale"
    @close="isOffcanvasOpen = false"
    @locale-change="handleLocaleChange"
  />
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { useRouteLocale, useLocaleSwitch } from '@/composables/locale'

const isOffcanvasOpen = ref(false)
const isFloatingVisible = ref(false)
const FLOATING_MENU_SCROLL_PX = 400

const { locale } = useI18n()
const { updateRouteLocale } = useRouteLocale()
const { currentLocale, changeLocale } = useLocaleSwitch({ updateRouteLocale })

const syncFloatingVisibility = () => {
  if (!import.meta.client) return
  isFloatingVisible.value = window.scrollY >= FLOATING_MENU_SCROLL_PX
}

onMounted(() => {
  syncFloatingVisibility()
  if (!import.meta.client) return
  window.addEventListener('scroll', syncFloatingVisibility, { passive: true })
})

onBeforeUnmount(() => {
  if (!import.meta.client) return
  window.removeEventListener('scroll', syncFloatingVisibility)
})

/**
 * Обработчик изменения локали - единственный источник истины для изменения локали
 */
const handleLocaleChange = async (newLocale: string) => {
  await changeLocale(newLocale)
}
</script>

<style scoped>
.site-header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: transparent;
}

.site-header--floating {
  position: fixed;
  z-index: 200;
}

.floating-header-enter-active,
.floating-header-leave-active {
  transition: opacity 180ms ease, transform 180ms ease;
}

.floating-header-enter-from,
.floating-header-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

.header-main {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  max-width: 1677px;
  width: 87%;
  margin: 0 auto;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  padding: 15px 30px;
}
@media (max-width: 1024px) {
  .main-nav {
    display: none;
  }
}

@media (max-width: 768px) {
  .header-main {
    width: 95%;
    padding: 15px 20px;
    margin-top: 15px;
  }
}

@media (max-width: 480px) {
  .header-main {
    margin: 15px 15px 0 15px;
    width: auto;
    padding: 12px 9px;
    box-sizing: border-box;
    max-height: 50px;
  }
}
</style>
